/**
 * Notification Events Utility
 * Enables communication between NotificationBell and NotificationsPage components
 */

export const notificationEvents = {
	// Event types
	MARK_ALL_AS_SEEN: 'notifications:markAllAsSeen',
	MARK_AS_SEEN: 'notifications:markAsSeen',
	REFRESH_COUNT: 'notifications:refreshCount',

	// Dispatch events
	markAllAsSeen: () => {
		window.dispatchEvent(new CustomEvent(notificationEvents.MARK_ALL_AS_SEEN));
	},

	markAsSeen: (notificationId) => {
		window.dispatchEvent(
			new CustomEvent(notificationEvents.MARK_AS_SEEN, {
				detail: { notificationId },
			})
		);
	},

	refreshCount: () => {
		window.dispatchEvent(new CustomEvent(notificationEvents.REFRESH_COUNT));
	},

	// Helper to add event listeners
	addEventListener: (eventType, handler) => {
		window.addEventListener(eventType, handler);
	},

	// Helper to remove event listeners
	removeEventListener: (eventType, handler) => {
		window.removeEventListener(eventType, handler);
	},
};
